export default "/images/branch.png?400674b44b06c7a780259771cf9385a2";